import { request } from '@/utils/request';

// 账号密码登录
export function userLogin(data) {
  return request.post({
    url: '/login',
    data,
  });
}

// 获取验证码
export function getVerificationCode(data) {
  return request.post({
    url: '/send/sms',
    data,
  });
}

// 验证码登录
export function userPhoneLogin(data) {
  return request.post({
    url: '/login/phone',
    data,
  });
}

// 获取用户信息
export function userInfo() {
  return request.get({
    url: '/api/v1/n/user/details',
  });
}

// 退出登录
export function userLogout() {
  return request.get({
    url: '/logout',
  });
}

// 用户注册
export function userRegister(data) {
  return request.post({
    url: '/register',
    data,
  });
}

// 修改密码
export function userUpdatePassword(data) {
  return request.post({
    url: '/api/v1/n/user/updatepassword',
    data,
  });
}
